"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/jsx-props-no-spreading */
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const native_1 = require("styled-components/native");
const Atoms_1 = require("../../Atoms");
const S = __importStar(require("./CheckBoxInput.styles"));
const CheckBoxInput = ({ label, defaultChecked = false, onPress, error, errorMessage, accessibilityLabel, accessibilityHint, testID, type = 'primary', }) => {
    const [checked, setChecked] = react_1.useState(defaultChecked);
    const theme = native_1.useTheme();
    const onChecked = () => {
        if (onPress) {
            onPress(!checked);
        }
        setChecked(!checked);
    };
    return (react_1.default.createElement(S.ViewContainer, { checked: checked, testID: "CheckBoxInput" },
        react_1.default.createElement(S.CheckBoxInputContainer, null,
            react_1.default.createElement(react_native_1.TouchableWithoutFeedback, { testID: testID, onPress: onChecked, accessibilityRole: "checkbox", accessibilityLabel: accessibilityLabel, accessibilityHint: accessibilityHint },
                react_1.default.createElement(S.CheckBox, { type: type, checked: checked, testID: "CheckBox" }, checked && (react_1.default.createElement(S.Check, null,
                    react_1.default.createElement(Atoms_1.Tick, { width: "100%", height: "100%", color: theme.checkBox[type].tick }))))),
            label && typeof label === 'string' ? (react_1.default.createElement(S.Label, { onPress: onChecked }, label)) : (react_1.default.createElement(S.LabelNode, null, label))),
        error && errorMessage && react_1.default.createElement(Atoms_1.ErrorLabel, null, errorMessage)));
};
exports.default = CheckBoxInput;
